import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export function Section({ children }) {
  return (
    <div className="section">
      <Container>
        {children}
      </Container>
    </div>
  );
}

export function SimpleSection({ children }) {
  return (
    <div className="section">
      <Container>
        <Row>
          <Col>
            {children}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Section;
